import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import Button from 'js/components/shared/Button';
import {searchBox} from '../../drupalSettings';
import ModuleByKey from '../../modules/ModuleByKey';

import styles from './SearchViewFull.module.scss';

const cx = classnames.bind(styles);
const wordings = searchBox?.titles;

const SearchViewFull = function ({className, modules, onSubmit}) {
  return (
    <div className={cx('root', className)}>
      {modules.map(type => (
        <ModuleByKey
          type={type}
          key={type}
          className={cx('module')}
        />
      ))}
      <Button
        type="submit"
        size="xl"
        theme="squared"
        className={cx('submit')}
        onClick={onSubmit}
      >
        {wordings.searchButtonValue}
      </Button>
    </div>
  )
}

SearchViewFull.propTypes = {
  data: PropTypes.any
}

export default SearchViewFull;
